import React from 'react';
import { Link } from 'react-router-dom';
import LogoLoader from '../../assets/LogoLoader.svg';

const Error404 = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        {/* Logo */}
        <div className="flex justify-center">
          <img
            src={LogoLoader}
            alt="Logo"
            className="h-16 w-auto opacity-90"
          />
        </div>

        {/* Error Content */}
        <div className="space-y-6">
          {/* Error Number */}
          <div className="space-y-2">
            <h1 className="text-8xl font-black text-gray-900 tracking-tight">
              404
            </h1>
            <div className="w-20 h-1 bg-gradient-to-r from-primary to-primary/70 mx-auto rounded-full"></div>
          </div>

          {/* Error Message */}
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">
              Page Not Found
            </h2>
            <p className="text-gray-600 leading-relaxed text-sm">
              The page you're looking for doesn't exist or has been moved. 
              For security reasons, some pages are restricted to authorized access only.
            </p>
          </div>

          {/* Quick Links */}
          <div className="pt-4">
            <p className="text-sm font-medium text-gray-500 mb-4">
              Quick Navigation
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              {[
                { path: "/", label: "Home" },
                { path: "/aboutus", label: "About" },
                { path: "/services", label: "Services" },
                { path: "/contactus", label: "Contact" },
                { path: "/blog", label: "Blog" }
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="inline-flex items-center px-3 py-2 text-xs font-medium text-primary bg-primary/5 rounded-lg hover:bg-primary/10 hover:text-primary/90 transition-all duration-200 border border-primary/10"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Primary Action */}
          <div className="pt-6">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 text-sm font-semibold text-white bg-primary rounded-lg hover:bg-primary/90 transition-colors duration-200 shadow-sm hover:shadow-md"
            >
              Return to Homepage
            </Link>
          </div>
        </div>

        {/* Support Text */}
        <div className="pt-8 border-t border-gray-200">
          <p className="text-xs text-gray-400">
            Need assistance?{" "}
            <Link to="/contactus" className="text-primary hover:text-primary/80 font-medium">
              Contact our support team
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Error404;